// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".prompt-rotate[data-v-74ac5ce3]{margin:0}.buttons[data-v-74ac5ce3]{display:flex;justify-content:flex-end;width:100%}", ""]);
// Exports
module.exports = exports;
